module.exports = __webpack_public_path__ + "static/media/secondary-air-system-monitor.9ee5268f.svg";